import React, {useState, useEffect} from "react";
import {UnlockService} from "../services/unlockService";
import {useTranslation} from "../i18n/LanguageProvider";

const UnlockPopup: React.FC = () => {
    const [code, setCode] = useState("");
    const [error, setError] = useState<string | null>(null);
    const [isUnlocked, setIsUnlocked] = useState(false);
    const [loading, setLoading] = useState(false);
    const {t} = useTranslation();

    useEffect(() => {
        const unlockStatus = localStorage.getItem("unlockStatus");
        if (unlockStatus === "unlocked") {
            setIsUnlocked(true);
        }
    }, []);

    const handleUnlock = async () => {
        setLoading(true);
        setError(null);
        try {
            await UnlockService.register(code);
            localStorage.setItem("unlockStatus", "unlocked");
            setIsUnlocked(true);
        } catch (err: any) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    if (isUnlocked) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4 overflow-y-auto">
            <div className="bg-white rounded-xl p-5 sm:p-6 max-h-[calc(100dvh-2rem)] overflow-y-auto w-full max-w-[30rem] shadow-xl text-center">
                <h2 className="text-xl font-bold mb-4">✈️ {t("unlock.title")}</h2>
                <p className="mb-4 text-base font-bold text-[#BEBEBE]">
                    {t("unlock.subtitle")}
                </p>

                <input
                    type="text"
                    placeholder={t("unlock.codePlaceholder")}
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === "Enter" && code && !loading) {
                            handleUnlock();
                        }
                    }}
                    className="w-full font-bold text-primary mb-4 px-4 py-2 border focus:outline-accent rounded-md"
                />

                {error && <p className="text-red-500 text-sm font-semibold mb-4">{error}</p>}

                <button
                    onClick={handleUnlock}
                    disabled={loading || !code}
                    className="bg-accent text-white font-semibold px-4 py-2.5 rounded-xl w-full hover:bg-violet-800 transition"
                >
                    {loading ? t("common.loading") : t("unlock.submit")}
                </button>

                <p className="mt-4 text-xs text-gray-400">
                    {t("unlock.footer")} <span className="font-semibold text-accent">info.farewise@gmail.com</span>!
                </p>
            </div>
        </div>
    );
};

export default UnlockPopup;
